module.exports = __webpack_public_path__ + "img/banner03_info_base.5b2a69c4.png";